var _ConnectionMap_parentMap;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class ConnectionMap {
    constructor() {
        _ConnectionMap_parentMap.set(this, void 0);
        __classPrivateFieldSet(this, _ConnectionMap_parentMap, new Map(), "f");
    }
    add(parentId, childId) {
        __classPrivateFieldGet(this, _ConnectionMap_parentMap, "f").set(childId, parentId);
    }
    get(childId) {
        return __classPrivateFieldGet(this, _ConnectionMap_parentMap, "f").get(childId);
    }
    log() {
        console.table(Array.from(__classPrivateFieldGet(this, _ConnectionMap_parentMap, "f").entries()));
    }
}
_ConnectionMap_parentMap = new WeakMap();
//# sourceMappingURL=ConnectionMap.js.map